<template>
    <div>
        <v-system-bar
            v-if="$vuetify.breakpoint.lgAndUp"
            :color="barColor"
            fixed   
            height="40px"
            app
            class="nav-top-header"
        >
            <v-btn
                v-if="!isElectron"    
                text
                color="white"        
                elevation=0
                href="https://ayuda.inmatic.ai/"
                target="_blank"
                rel="nofollow"
            >      
                <v-icon color="white">mdi-lightbulb-outline</v-icon> 
                AYUDA
            </v-btn>
            <v-btn
                v-if="!isElectron"
                text
                color="white"      
                elevation=0
                href="https://app.inmatic.ai"
            >
                <v-icon color="white">mdi-account-outline</v-icon>
                ÁREA CLIENTES
            </v-btn>
        </v-system-bar>
        <v-app-bar
            app
            :color="barColor"            
            height="100"
            :flat="true"            
            >
            <a :href="!isElectron ? 'https://inmatic.ai': '#'">
                <v-img class="ml-5 dragBar" src="/logo_blanc.png" contain max-width="150" alt="inmatic"></v-img>
            </a>
            <v-spacer></v-spacer>
    
            <div v-for="(elem, i) in menu" :key="`${i}-navbar`" v-if="!isElectron">

                <template v-if="elem.dropdown">
                    <v-menu          
                        offset-y>
                        <template v-slot:activator="{ attrs, on }">
                            <v-btn
                                v-show="!elem.onlyDrawer && $vuetify.breakpoint.lgAndUp"            
                                v-bind="attrs"            
                                v-on="on"
                                color="white" 
                                elevation="0"      
                                :class="navbarElmClass(elem)"
                                class="hidden-md-and-down navbar__elm navbar__elm__dropdown"
                            >
                                {{elem.name.toUpperCase() }} <v-icon>mdi-chevron-down</v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item 
                                v-for="(submenu_elem, index) in elem.submenu" 
                                :key="index"                                
                                :href="submenu_elem.href"
                                @click="goTo(submenu_elem)"
                                :target="submenu_elem.target">
                                <v-list-item-title>{{ submenu_elem.name }}</v-list-item-title>            
                            </v-list-item>  
                        </v-list>        
                    </v-menu>                   
                </template>
                <template v-else>
                    <v-btn
                        text
                        v-show="!elem.onlyDrawer && elem.href && $vuetify.breakpoint.lgAndUp"                       
                        v-bind="elem"
                        color="white"
                        :href="elem.href"
                        @click="goTo(elem)"
                        :target="elem.target"
                        class="hidden-md-and-down navbar__elm"
                        :class="navbarElmClass(elem)"
                    >
                        {{elem.name.toUpperCase()}}
                    </v-btn>
                </template>
            </div>
            <v-btn v-if="!isElectron"
                rounded
                elevation="0"
                color="#1bbff7"
                class="hidden-md-and-down font-weight-bold white--text"  
                :href="hrefSignupOnPage ? '#signup-form' : 'https://app.inmatic.ai/signup'"
            >
                PRUÉBALO AHORA
            </v-btn>


            <v-app-bar-nav-icon
                v-if="!isElectron"
                class="hidden-lg-and-up"
                @click="drawer=!drawer"
                color="white"
            />


            <v-btn
                v-if="isElectron"                
                icon
                color="white"
                v-on:click="electronMinimize()"
            >
                <v-icon class="white-color" v-once>
                mdi-window-minimize
                </v-icon>  
            </v-btn> 
            <v-btn
                v-if="isElectron && maximized"                
                icon
                color="white"
                v-on:click="electronRestore()"
            >
                <v-icon v-once class="white-color">
                mdi-window-restore
                </v-icon>  
            </v-btn>   
            <v-btn
                v-if="isElectron && !maximized"                
                icon
                color="white"
                v-on:click="electronMaximize()"
            >
                <v-icon v-once class="white-color">
                mdi-window-maximize
                </v-icon>  
            </v-btn>  
            <v-btn
                v-if="isElectron"                
                icon
                color="white"
                v-on:click="electronClose()"
            >
                <v-icon class="white-color" v-once>
                mdi-window-close
                </v-icon>  
            </v-btn> 
        </v-app-bar>

        <v-navigation-drawer
            v-model="drawer"
            app
            temporary
            right
            class="drawer__inmatic"
        >
            <v-list>
                <div 
                v-for="(elem, i) in menu" 
                :key="i"
                >
                    <v-list-item
                    v-if="!elem.dropdown"
                    >            
                        <v-btn 
                            text
                            :key="i"
                            v-bind="elem"
                            color="#050D4C" 
                            @click="goTo(elem)"
                            :href="elem.href"
                            :target="elem.target"
                            class="text-body-1"
                        >
                        {{elem.name}}
                        </v-btn>

                    </v-list-item>
                    <v-list-group
                        v-else
                        :value="false"
                        no-action
                        sub-group           
                        >
                        <template v-slot:activator>
                            <v-list-item-title class="text-body-1">{{elem.name}}</v-list-item-title>
                        </template>               
                        <v-list-item
                            v-for="(submenu_elem, x) in elem.submenu" 
                            :key="x"
                        >
                            <v-btn 
                                :key="x" 
                                class="text-body-1"                                 
                                text
                                color="#050d4c"                                                                  
                                :href="submenu_elem.href"
                                @click="goTo(submenu_elem)"
                            >
                                {{submenu_elem.name}}
                            </v-btn>
                        </v-list-item>        
                    </v-list-group>
                </div>
            <v-list-item>
                <v-btn
                    rounded
                    elevation="0"
                    color="#1bbff7"
                    class="font-weight-bold white--text"  
                    :href="hrefSignupOnPage ? '#signup-form' : 'https://app.inmatic.ai/signup'"
                >
                    PRUÉBALO AHORA
                </v-btn>               
            </v-list-item>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>

<script>
    export default {
        name: 'AppHeaderPublic',
        props: {
            hrefSignupOnPage: {
                type: Boolean,
                default: false,
            },
            transparentHeader: {
                type: Boolean,
                default: true,
            }
        },
        data() {
            return {      
                menu:[
                    {name: 'Inicio', href: 'https://inmatic.ai/', onlyDrawer: true},
                    {name: '¿Cómo funciona?', href: 'https://inmatic.ai/como-funciona/', onlyDrawer: false},
                    {name: 'Compatibilidad', href: 'https://inmatic.ai/compatibilidad/', onlyDrawer: false},
                    {name: 'Tarifas', href: 'https://inmatic.ai/tarifas/', onlyDrawer: false},
                    {name: 'Bancos', href: 'https://inmatic.ai/bancos/', onlyDrawer: false},
                    {name: 'Recursos', href: 'https://inmatic.ai/recursos/', onlyDrawer: false, dropdown: true, 
                        submenu: [          
                        {name: 'Blog', href:'https://inmatic.ai/blog/'},
                        {name: 'Casos de éxito', href:'https://inmatic.ai/casos-de-exito/'},
                        {name: 'Webinar', href: 'https://inmatic.ai/webinar/como-reducir-a-la-mitad-el-proceso-contable-de-tu-cierre-trimestral/'},
                        {name:'Partners', href: 'https://inmatic.ai/partners/'},
                        ]
                    },      
                    {name: 'Kit Digital', href: 'https://inmatic.ai/kit-digital/', onlyDrawer: false},
                    {name: 'Contacto', href: 'https://inmatic.ai/contacto/',onlyDrawer: false},
                    {name: 'Ayuda', href: 'https://ayuda.inmatic.ai/es/', target: '_blank', onlyDrawer: true},
                    {name: 'Área clientes', href: 'https://app.inmatic.ai', hash: false, onlyDrawer: true},
                ],               
                drawer:false,
                scrollPosition: null, 
                isElectron: false,
                maximized:true,             
            }
        },
        computed: {       
            barColor () {
                if (!this.transparentHeader || this.scrollPosition > 50) {
                    return "#050D4C";
                }
                else {
                    return "transparent";
                }            
            },        
        },
        mounted(){        
            window.addEventListener('scroll', this.updateScroll);
            this.isElectron = navigator.userAgent == 'InmaticApp';
        },
        methods: {      
            goTo(elem){
                if(elem.pathName){
                    this.$router.push({'name': elem.pathName})
                }
            },                
            updateScroll() {
                this.scrollPosition = window.scrollY
            },
            navbarElmClass(elm) { 
                let classes = '';           
                if (elm.name != "Contacto") {
                    classes = 'navbar__elm__has-bar ';
                } else {
                    classes = 'mr-2 ';
                }
                return classes;
            },
            electronClose(){
                window.electronAPI.quit().then(() => {
                    console.log("windowClosed")
                });
            },
            electronMinimize(){
                window.electronAPI.minimize().then(() => {
                    console.log("windowMinized")
                });
            },
            electronRestore(){
                window.electronAPI.restore().then(() => {
                    console.log("windowRestored")
                });
                this.maximized=false;
            },
            electronMaximize(){
                window.electronAPI.maximize().then(() => {
                    console.log("windowMaximized")
                });
                this.maximized=true;
            },
        }
    }
</script>

<style scoped>
    .white-color {
        color:white !important;
    }
    .navbar__elm {
        font-weight: 400;
        padding: 0 8px !important;
        margin: 0 !important;
        font-family: "Roboto", sans-serif !important;        
    }
    .navbar__elm__dropdown {
        padding-left: 8px !important;
        padding-right: 8px !important;
        background-color: transparent !important;
        color:white;
    }
    .v-system-bar.nav-top-header {
        transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1) transform, 0.2s cubic-bezier(0.4, 0, 0.2, 1) background-color, 0.2s cubic-bezier(0.4, 0, 0.2, 1) left, 0.2s cubic-bezier(0.4, 0, 0.2, 1) right, 280ms cubic-bezier(0.4, 0, 0.2, 1) box-shadow, 0.25s cubic-bezier(0.4, 0, 0.2, 1) max-width, 0.25s cubic-bezier(0.4, 0, 0.2, 1) width;
        text-align:right;
        justify-content:right;
        
    }
    .v-system-bar.nav-top-header .v-btn {
        font-weight: 400;
    }
    .navbar__elm__has-bar::after {
        content: " ";
        position: absolute; 
        width: 1px;
        right: 0; 
        height: 16px;
        background-color: #9117CC;
    }
    .v-toolbar .text-body-1,  
    .v-navigation-drawer .text-body-1 {
      font-family: "Roboto",sans-serif !important; 
      font-size: 0.875rem !important;
    }
    .v-toolbar .v-btn,
    .v-navigation-drawer .v-btn {
        text-transform:none;
        letter-spacing: 0.0892857143em !important;
    }

    .drawer__inmatic .v-list-group--no-action.v-list-group--sub-group .v-list-item__title {
        color: #050d4c;
        letter-spacing: 0.0892857143em !important;        
    }
    .drawer__inmatic .v-list-group--no-action.v-list-group--sub-group > .v-list-group__items > .v-list-item {
        padding-left: 35px;
    } 

    .drawer__inmatic >>> .v-list-group--no-action.v-list-group--sub-group .v-list-group__header__prepend-icon {
        margin-right: 5px !important;
    }

    @media screen and (min-width: 1264px) {
        .v-app-bar.v-app-bar--fixed >>> .v-toolbar__content {
            padding: 4px 50px;
        }
        .v-system-bar.nav-top-header {
            padding-left:50px;
            padding-right: 50px;
            padding-top:5px;
        }
        .v-system-bar.nav-top-header .v-btn {
            padding:0px 5px;   
            height: 30px; 
        }

    }         
</style>